let loginForm = document.getElementById("login-form");
let btn_2fa = document.getElementById("2fa-btn");
let ajaxUrl = glide_custom_data.ajax_url;
let loginNonce = glide_custom_data.ajax_nonce;

if( loginForm ) {
    loginForm.addEventListener("submit", function (event) {
        event.preventDefault();

        $('#login-modal-trigger').click();
        
        let email = document.getElementById('email').value.trim();
        let password = document.getElementById('password').value.trim();
        let emailValid = false;
        let passwordValid = false;
        
        if( email == '' ) {
            emailValid = false;
            glide_ajax_loader_hide();
            $('.message-text .invalid-2fa').show();
            $('.message-text .input-2fa').hide();
            $('.message-text .invalid-2fa').html('<p>Email is required</p>');
        } else {
            if( validateEmail(email) ) {
                emailValid = true;
            } else {
                emailValid = false;
                glide_ajax_loader_hide();
                $('.message-text .invalid-2fa').show();
                $('.message-text .input-2fa').hide();
                $('.message-text .invalid-2fa').html('<p>Enter valid email</p>');
            }
        }

        if( emailValid ) {
            if( password == '' ) {
                passwordValid = false;
                glide_ajax_loader_hide();
                $('.message-text .invalid-2fa').show();
                $('.message-text .input-2fa').hide();
                $('.message-text .invalid-2fa').html('<p>Password is required</p>');
            } else {
                passwordValid = true;
            }
        }

        if( passwordValid ) {

            var formData = {
                action: "user_login",
                email: email,
                password: password,
                loginNonce: loginNonce,
            };

            glide_ajax_loader_show();

            $('.message-text .input-2fa').show();
            $('.message-text .invalid-2fa').hide();

            jQuery.ajax({
                url: ajaxUrl,
                type: "POST",
                data: formData,
                success: function (response) {
                    logged = response.data.message;

                    if( response.success ) {
                        window.location.href = logged;
                    } else {
                        glide_ajax_loader_hide();
                        if( logged == 'email' ) {
                            $('.message-text .invalid-2fa').show();
                            $('.message-text .input-2fa').hide();
                            // $('.message-text .invalid-2fa').html('<p>The email entered <br> does not match any <br> in our records. <br> Please try again or contact our <br> system administrator.</p>');
                            $('.message-text .invalid-2fa').html('<p>Invalid Email or Password<br> Please try again or contact our <br> system administrator.</p>');

                        }
                        if( logged == 'password' ) {
                            $('.message-text .invalid-2fa').show();
                            $('.message-text .input-2fa').hide();
                            // $('.message-text .invalid-2fa').html('<p>Password for <br> the account is <br> incorrect</p>');
                            $('.message-text .invalid-2fa').html('<p>Invalid Email or Password</p>');
                        }
                        if( logged == 'attack' ) {
                            $('.message-text .invalid-2fa').show();
                            $('.message-text .input-2fa').hide();
                            $('.message-text .invalid-2fa').html('<p>Our system is facing <br> technical issues <br> logging in. <br> Please try again <br> in a few minutes</p>');
                        }
                    }
                },
                error: function () {
                    glide_ajax_loader_hide();
                    $('.message-text .invalid-2fa').show();
                    $('.message-text .input-2fa').hide();
                    $('.message-text .invalid-2fa').html('<p>Our system is facing <br> technical issues <br> logging in. <br> Please try again <br> in a few minutes</p>');
                },
            });
        }

    });

    if( btn_2fa ) {
        btn_2fa.addEventListener("click", function (event) {
            let code2fa = document.getElementById("2fa-code");
            if( code2fa && code2fa.value.trim() ) {
                let email = document.getElementById('email').value.trim();
                let password = document.getElementById('password').value.trim();

                var formData = {
                    action: "user_login_with_2fa",
                    email: email,
                    password: password,
                    loginNonce: loginNonce,
                    code2fa: code2fa.value,
                };

                glide_ajax_loader_show();

                document.getElementById('2fa-code').value = '';
                $('.input-2fa__error').hide();

                jQuery.ajax({
                    url: ajaxUrl,
                    type: "POST",
                    data: formData,
                    success: function (response) {
                        logged = response.data.message;

                        console.log(logged)
                
                        if( response.success ) {
                            window.location.href = logged;
                        } else {
                            glide_ajax_loader_hide();
                            if( logged == 'attack' ) {
                                $('.message-text .invalid-2fa').show();
                                $('.message-text .input-2fa').hide();
                                $('.message-text .invalid-2fa').html('<p>Our system is facing <br> technical issues <br> logging in. <br> Please try again <br> in a few minutes</p>');
                            }
                            if( logged == 'password' ) {
                                $('.message-text .invalid-2fa').hide();
                                $('.message-text .input-2fa').show();
                                $('.message-text .input-2fa .input-2fa__error').css('display', 'block');

                                // $('.message-text .invalid-2fa').html('<p>Invalid 2fa code entered</p>');
                            }
                        }
                    },
                    error: function () {
                        glide_ajax_loader_hide();
                        $('.message-text .invalid-2fa').show();
                        $('.message-text .input-2fa').hide();
                        $('.message-text .invalid-2fa').html('<p>Our system is facing <br> technical issues <br> logging in. <br> Please try again <br> in a few minutes</p>');
                    },
                });
            }
        });
    }

}